module.exports = __webpack_public_path__ + "static/media/摄图网_2.b2a7ded7.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_208/images/摄图网_2.png
// module id = 1706
// module chunks = 0